export default Object.freeze({
  green56: '#E2FFEF',
  white0: '#FFFFFF',
  grey2: '#F9F9F9',
  grey7: '#EEEEEE',
  grey13: '#DDDDDD',
  grey20: '#CCCCCC',
  grey31: '#AFAFAF',
  grey33: '#AAAAAA',
  grey34: '#AFAFA6',
  grey40: '#999999',
  grey48: '#80868B',
  grey60: '#666666',
  grey69: '#424D5C',
  black3: '#333333',
  black82: '#282D36',
  black87: '#1D2127',
  red67: '#FF0100',
  red55: '#DB4437',
  green54: '#00B261',
  purple83: '#8d3f8c',
  blue28: '#91BED4',
  blue71: '#304269',
  blue53: '#1486CA',
});
